import React from 'react';
import { node, number, oneOf, oneOfType, string } from 'prop-types';
import { styContainer } from './style';

const Container = (props) => {
  const { children, className, color, padding, scrollable, ...rest } = props;

  return (
    <div
      className={`${styContainer({ color, padding, scrollable })} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

Container.propTypes = {
  children: node,
  className: string,
  color: string,
  padding: oneOfType([string, number]),
  scrollable: oneOf([true, 'x', 'y', false]),
};

Container.defaultProps = {
  children: null,
  className: '',
  color: '',
  padding: '0px 16px',
  scrollable: false,
};

export default Container;
